---
title: Project Template
coverImage: https://picsum.photos/200
date: 2023-09-26T02:32:00.000Z
excerpt: Template for project reports
hidden: true
tags:
---

<script>import Image from "@lib/components/atoms/Image.svelte";</script>

### General idea

What is the thing I'm trying to make?

#### Links, inspiration, etc

### Learnings

### Todo

- [x] Write the press release
- [ ] Update the website
- [ ] Contact the media
